import { buildStepUpForm, type StepUpFormOptions, type StepUpResult } from './form'
import { stepUpFormStyles } from './style'

// Rendering into a target wipes whatever was there, so a second render would leave the first
// call's Promise pending forever with its form gone from the page. Cancel the previous flow
// first, so that `await` settles with 'cancelled' instead of hanging. Keyed by target, so two
// separate containers stay independent of each other.
const activeByTarget = new WeakMap<HTMLElement, () => void>()

export function renderStepUpInline(target: HTMLElement, options: StepUpFormOptions): Promise<StepUpResult> {
  activeByTarget.get(target)?.()

  const shadow = target.shadowRoot ?? target.attachShadow({ mode: 'open' })
  shadow.innerHTML = ''

  const style = document.createElement('style')
  style.textContent = stepUpFormStyles
  shadow.appendChild(style)

  const formContainer = document.createElement('div')
  shadow.appendChild(formContainer)

  return new Promise((resolve, reject) => {
    const handle = buildStepUpForm(
      formContainer,
      options,
      (result) => resolve(result),
      (error) => reject(error),
      () => {
        shadow.innerHTML = ''
      },
    )
    activeByTarget.set(target, handle.requestCancel)
  })
}
